export enum NextAssignmentVisibilities {
  submitted = "submitted",
  graded = "graded",
  accepted = "accepted",
}
